import { render, staticRenderFns } from "./FlightFolderHistory.vue?vue&type=template&id=670c015a&scoped=true&"
import script from "./FlightFolderHistory.vue?vue&type=script&lang=js&"
export * from "./FlightFolderHistory.vue?vue&type=script&lang=js&"
import style0 from "./FlightFolderHistory.vue?vue&type=style&index=0&id=670c015a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670c015a",
  null
  
)

export default component.exports